import { useState } from "react";

// ── Change this to whatever password you want ──────────────────
const SITE_PASSWORD = "pangaea1964";
// ──────────────────────────────────────────────────────────────

export default function PasswordGate({ onUnlock }) {
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);
  const [shake, setShake] = useState(false);

  const check = () => {
    if (value === SITE_PASSWORD) {
      // Remember in sessionStorage so refreshing doesn't log you out
      sessionStorage.setItem("phk_unlocked", "true");
      onUnlock();
    } else {
      setError(true);
      setShake(true);
      setValue("");
      setTimeout(() => { setError(false); setShake(false); }, 1000);
    }
  };

  const handleKey = (e) => { if (e.key === "Enter") check(); };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&family=DM+Sans:wght@400;500;600&display=swap');
        @keyframes shake {
          0%,100% { transform: translateX(0); }
          20%      { transform: translateX(-8px); }
          40%      { transform: translateX(8px); }
          60%      { transform: translateX(-5px); }
          80%      { transform: translateX(5px); }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .gate-card {
          animation: fadeIn 0.5s ease both;
        }
        .gate-shake {
          animation: shake 0.5s ease both;
        }
      `}</style>

      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(155deg, #2d5c3a 0%, #4a7c59 55%, #87c5d6 100%)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "24px", fontFamily: "'DM Sans', sans-serif",
      }}>
        <div className="gate-card" style={{
          background: "rgba(255,255,255,0.97)", borderRadius: 20,
          padding: "clamp(36px, 5vw, 56px) clamp(28px, 5vw, 52px)",
          maxWidth: 420, width: "100%", textAlign: "center",
          boxShadow: "0 24px 64px rgba(0,0,0,0.18)",
        }}>
          {/* Logo */}
          <div style={{ marginBottom: 28 }}>
            <svg width="52" height="52" viewBox="0 0 80 80" fill="none">
              <circle cx="40" cy="32" r="26" fill="#87c5d6"/>
              <path d="M22 20 Q28 14 38 18 Q44 22 42 30 Q38 36 32 34 Q24 30 22 20Z" fill="#4a7c59"/>
              <path d="M46 18 Q56 16 58 26 Q58 34 52 38 Q46 40 44 34 Q42 26 46 18Z" fill="#4a7c59"/>
              <path d="M26 36 Q30 42 28 46 Q24 44 22 38 Q22 34 26 36Z" fill="#4a7c59"/>
              <circle cx="40" cy="32" r="26" fill="none" stroke="#2d5c3a" strokeWidth="3"/>
              <ellipse cx="40" cy="28" rx="7" ry="8" fill="#1e2520"/>
              <path d="M26 52 Q28 40 40 40 Q52 40 54 52Z" fill="#1e2520"/>
              <path d="M18 54 Q29 49 40 52 Q51 49 62 54 L60 62 Q49 57 40 60 Q31 57 20 62Z" fill="#1e2520"/>
              <line x1="40" y1="52" x2="40" y2="60" stroke="#f0ece4" strokeWidth="1.5"/>
            </svg>
            <div style={{ marginTop: 10 }}>
              <div style={{ fontFamily: "'Playfair Display', serif", fontWeight: 900, fontSize: 20, color: "#1e2520" }}>PANGAEA'S</div>
              <div style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 500, fontSize: 11, color: "#4a7c59", letterSpacing: "0.12em", textTransform: "uppercase" }}>Health & Knowledge</div>
            </div>
          </div>

          <h2 style={{ fontFamily: "'Playfair Display', serif", fontWeight: 900, fontSize: 24, color: "#1e2520", marginBottom: 8 }}>
            Site under construction
          </h2>
          <p style={{ fontSize: 14, color: "#6b7c72", marginBottom: 32, lineHeight: 1.65 }}>
            This site is currently private while we finish building it. Enter the access password to preview.
          </p>

          <label style={{ display: "block", fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em", color: "#6b7c72", textAlign: "left", marginBottom: 7 }}>
            Access password
          </label>

          <div className={shake ? "gate-shake" : ""}>
            <input
              type="password"
              value={value}
              onChange={e => { setValue(e.target.value); setError(false); }}
              onKeyDown={handleKey}
              placeholder="Enter password…"
              autoFocus
              style={{
                width: "100%", padding: "13px 16px", borderRadius: 10,
                border: `1.5px solid ${error ? "#c0392b" : "rgba(74,124,89,0.25)"}`,
                fontSize: 15, fontFamily: "'DM Sans', sans-serif",
                color: "#1e2520", outline: "none",
                background: error ? "#fff5f5" : "#f9f8f6",
                transition: "border-color 0.2s, background 0.2s",
              }}
              onFocus={e => { if (!error) e.target.style.borderColor = "#4a7c59"; e.target.style.background = "#fff"; }}
              onBlur={e => { if (!error) e.target.style.borderColor = "rgba(74,124,89,0.25)"; }}
            />
          </div>

          {error && (
            <p style={{ marginTop: 10, fontSize: 13, color: "#c0392b", fontWeight: 500, textAlign: "left" }}>
              Incorrect password. Please try again.
            </p>
          )}

          <button
            onClick={check}
            style={{
              width: "100%", marginTop: 16, padding: "14px", borderRadius: 10,
              background: "#2d5c3a", color: "#fff",
              fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: 15,
              border: "none", cursor: "pointer", transition: "opacity 0.2s",
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = "0.87"}
            onMouseLeave={e => e.currentTarget.style.opacity = "1"}
          >
            Enter site
          </button>

          <p style={{ marginTop: 28, fontSize: 12, color: "#b4b2a9", lineHeight: 1.7 }}>
            Pangaea's Health and Knowledge is not yet publicly available.<br />
            Contact <a href="mailto:pangaeashk@gmail.com" style={{ color: "#4a7c59", fontWeight: 600 }}>pangaeashk@gmail.com</a> for access.
          </p>
        </div>
      </div>
    </>
  );
}
